import './TechBand.css';

const ITEMS = [
  'ERP', 'BI & Analytics', 'Cloud', 'LGPD', 'Integrações',
  'Saúde Digital', 'RH & Folha', 'Financeiro', 'CRM', 'Relatórios',
];

const TechBand = () => (
  <div className="techband">
    <span className="techband__label">Ecossistema</span>
    <div className="techband__sep" aria-hidden="true" />
    <div className="techband__items">
      {ITEMS.map((item) => (
        <span className="techband__item" key={item}>{item}</span>
      ))}
    </div>
  </div>
);

export default TechBand;
